import { Zap, BadgeDollarSign, Phone, MapPin, Star } from "lucide-react";
import { Link } from "react-router-dom";

export const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-amber-500/15 bg-[#0B0F17]">
    <div className="px-4 sm:px-8 lg:px-12 max-w-7xl mx-auto py-14 grid grid-cols-1 md:grid-cols-3 gap-10">
      <div>
        <div className="flex items-center gap-2 mb-4">
          <span className="w-8 h-8 bg-amber-500 flex items-center justify-center">
            <Zap className="w-5 h-5 text-slate-950" strokeWidth={2.5} />
          </span>
          <span className="font-condensed font-extrabold uppercase tracking-wide text-lg">
            Fix <span className="text-amber-500">&amp;</span> Finish
          </span>
        </div>
        <p className="text-sm text-slate-400 leading-relaxed max-w-xs">
          Handyman services done right the first time. Book online, we show up, you pay at the job site.
        </p>
        <a href="tel:+61480573604" data-testid="footer-phone-link"
           className="mt-5 inline-flex items-center gap-3 border border-amber-500/40 hover:border-amber-500 px-4 py-3 transition-colors duration-300 group">
          <Phone className="w-4 h-4 text-amber-500" />
          <span className="text-left">
            <span className="block text-[10px] font-mono-brand uppercase tracking-[0.2em] text-slate-500 group-hover:text-slate-400">Call or text</span>
            <span className="block font-condensed font-bold text-lg text-slate-100 group-hover:text-amber-400 transition-colors">0480 573 604</span>
          </span>
        </a>
        <p className="mt-4 flex items-center gap-2 text-xs text-slate-500" data-testid="footer-service-area">
          <MapPin className="w-3.5 h-3.5 text-amber-500 shrink-0" />
          Caroline Springs &amp; surrounding areas, Melbourne VIC
        </p>
        <a href="https://www.google.com/maps/search/Fix+and+Finish+Handyman+Services+Caroline+Springs+VIC"
           target="_blank" rel="noopener noreferrer" data-testid="footer-google-link"
           className="mt-4 inline-flex items-center gap-3 border border-slate-700 hover:border-amber-500/60 px-4 py-3 transition-colors duration-300 group">
          <Star className="w-4 h-4 text-amber-500 fill-amber-500" />
          <span className="text-left">
            <span className="block text-[10px] font-mono-brand uppercase tracking-[0.2em] text-slate-500 group-hover:text-slate-400">Find us on Google</span>
            <span className="block text-sm font-medium text-slate-200 group-hover:text-amber-400 transition-colors">Reviews &amp; directions on Maps</span>
          </span>
        </a>
      </div>
      <div>
        <p className="text-xs font-mono-brand uppercase tracking-[0.25em] text-amber-400 mb-4">Services</p>
        <ul className="text-sm text-slate-400 space-y-2">
          <li>Lawn Mowing &amp; Garden Weeding</li>
          <li>Gutter Cleaning</li>
          <li>Pressure Washing Driveways</li>
          <li>Fence Repair &amp; Builds</li>
          <li>Painting &amp; General Handyman</li>
        </ul>
      </div>
      <div>
        <p className="text-xs font-mono-brand uppercase tracking-[0.25em] text-amber-400 mb-4">The Promise</p>
        <div className="flex items-start gap-3 border border-amber-500/30 bg-amber-500/5 p-4">
          <BadgeDollarSign className="w-5 h-5 text-amber-400 shrink-0 mt-0.5" />
          <p className="text-sm text-slate-300">
            Pay directly at the job site. No deposits, no online payments, no surprises.
          </p>
        </div>
      </div>
    </div>
    <div className="hazard-stripes h-2" />
    <div className="px-4 sm:px-8 lg:px-12 max-w-7xl mx-auto py-5 flex flex-wrap items-center justify-between gap-3">
      <p className="text-xs text-slate-600">© {new Date().getFullYear()} Fix &amp; Finish Handyman Services</p>
      <Link to="/admin/login" data-testid="footer-admin-link" className="text-xs text-slate-600 hover:text-amber-400 transition-colors">
        Owner Login
      </Link>
    </div>
  </footer>
);
